<form class="flex flex-col gap-3" [formGroup]="form" (ngSubmit)="onSubmit()">
  <et-atoms-input class="w-full">
    <label>First delay days</label>
    <input
      etAtomsInput
      formControlName="firstDelayDays"
      type="number"
      [min]="limits.firstDelayDays.min"
      [max]="limits.firstDelayDays.max"
      required
    />
    @if ( form.controls.firstDelayDays.touched &&
    form.controls.firstDelayDays.hasError('required') ) {
    <span etAtomsInputError>First delay days is required</span>
    } @if ( form.controls.firstDelayDays.touched &&
    (form.controls.firstDelayDays.hasError('min') ||
    form.controls.firstDelayDays.hasError('max')) ) {
    <span etAtomsInputError>First delay days is invalid</span>
    }
  </et-atoms-input>

  <et-atoms-input class="w-full">
    <label>Interval days</label>
    <input
      etAtomsInput
      formControlName="intervalDays"
      type="number"
      [min]="limits.intervalDays.min"
      [max]="limits.intervalDays.max"
      required
    />
    @if ( form.controls.intervalDays.touched &&
    form.controls.intervalDays.hasError('required') ) {
    <span etAtomsInputError>Interval days is required</span>
    } @if ( form.controls.intervalDays.touched &&
    (form.controls.intervalDays.hasError('min') ||
    form.controls.intervalDays.hasError('max')) ) {
    <span etAtomsInputError>Interval days is invalid</span>
    }
  </et-atoms-input>

  <et-atoms-input class="w-full">
    <label>Max rounds</label>
    <input
      etAtomsInput
      formControlName="maxRounds"
      type="number"
      [min]="limits.maxRounds.min"
      [max]="limits.maxRounds.max"
      required
    />
    @if ( form.controls.maxRounds.touched &&
    (form.controls.maxRounds.hasError('min') ||
    form.controls.maxRounds.hasError('max')) ) {
    <span etAtomsInputError>Max rounds is invalid</span>
    }
  </et-atoms-input>

  @if (hideSms === false) {
  <div class="form-control">
    <label class="label w-fit cursor-pointer p-0">
      <input
        type="checkbox"
        class="checkbox mr-2"
        formControlName="emailEnabled"
      />
      <span class="text-base font-medium">Email enabled</span>
    </label>
  </div>

  <div class="form-control">
    <label class="label w-fit cursor-pointer p-0">
      <input
        type="checkbox"
        class="checkbox mr-2"
        formControlName="smsEnabled"
      />
      <span class="text-base font-medium">SMS enabled</span>
    </label>
  </div>
  }
  <!-- Form error messages -->
  @if (form.touched && form.errors?.['emailOrSmsRequired']) {
  <p class="m-0 text-error">Email or SMS is required</p>
  }

  <div class="flex justify-end gap-2">
    <button
      type="button"
      class="btn btn-outline btn-sm rounded-full normal-case min-w-[70px]"
      (click)="cancelled.emit()"
    >
      Cancel
    </button>
    <button
      type="submit"
      class="btn btn-primary btn-sm rounded-full normal-case min-w-[70px]"
    >
      Save
    </button>
  </div>
</form>
